export default __webpack_public_path__ + "static/media/login_bg_1200.c11e0195.png";